import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import responseHandler from "responseHandler";
import { DatePicker, Button, Grid } from "react-md";
import { MSelect, MSpinner} from "components/Shared";
import { postExtensionRequest } from "requests/inspectorCases";

const STATUS = {
  // ui states
  NONE: "NONE",
  SUBMITTING: "SUBMITTING",

  // response states
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  ERROR: "ERROR",
};

const extensionReasons = [
  { needReasonDate: true, value: 'Appointment has been scheduled for:', label: 'Appointment has been scheduled for:' },
  { needReasonDate: true, value: 'Delayed Closing, need to call PH/Borrower back:', label: 'Delayed Closing, call PH/Borrower back:' },
  { needReasonDate: true, value: 'Policyholder requested a call back after:', label: 'Policyholder requested a call back after:' },
  { needReasonDate: false, value: 'Agent contacting PH on Mueller behalf', label: 'Agent contacting PH on Mueller behalf' },
  { needReasonDate: false, value: 'Broker contacting borrower on Mueller behalf', label: 'Broker contacting borrower on Mueller behalf' },
  { needReasonDate: false, value: 'Received case past due, contact attempts to begin immediately', label: 'Received past due, starting contact attempts' },
  { needReasonDate: false, value: 'Received alternate contact number, starting attempts to schedule', label: 'Alternate contact, starting contact attempts' },
  { needReasonDate: false, value: 'Customer Service requested, permission to close out requested', label: 'Customer Service, permission to close request' },
  { needReasonDate: false, value: 'Manager assistance requested', label: 'Manager assistance requested' },
  { needReasonDate: false, value: 'No trespassing or Gated Community, policyholder/agent contact required', label: 'No Trespass/Gated, PH/agent contact needed' },
  { needReasonDate: false, value: 'Original appointment needs to be rescheduled, appointment efforts resuming', label: 'Original appointment needs to be rescheduled' },
];

const RequestExtension = ({ match: { params }, makeToast}) => {
  const mounted = useRef(true);

  const [status, setStatus] = useState(STATUS.NONE);
  const [dueDate, setDueDate] = useState(new Date());
  const [details, setDetails] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [reasonDate, setReasonDate] = useState(null);

  const controlIdNumber = params.controlIdNumber;

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  const submitRequest = () => {

    // guard clauses
    if(dueDate.getTime() < new Date().getTime()){
      makeToast("Requested Date cannot be in the past");
      return;
    }
    if(!details.length){
      makeToast("Please fill in the reason for extension");
      return;
    }
    if(showDatePicker && reasonDate == null){
      makeToast("Reason Date is required");
      return;
    }

    setStatus(STATUS.SUBMITTING);

    let combinedDetails = details;
    if(reasonDate != null) {
      combinedDetails = combinedDetails + ' ' + reasonDate;
    }

    // post it
    postExtensionRequest(controlIdNumber, dueDate.toISOString(), combinedDetails, (response) => {
      if(response.autoApproved){
        setStatus(STATUS.APPROVED);
      }
      else if(response.success) {
        setStatus(STATUS.PENDING);
      }
      else {
        setErrorMessage(response.message);
        setStatus(STATUS.ERROR);
      }
    }, mounted);
  };

  const onReasonForExtensionChange = (e) => {
    setDetails(e.value);
    if(e.needReasonDate){
      setShowDatePicker(true);
    }
    else{
      setShowDatePicker(false);
      setReasonDate(null);
    }
  };

  return (
    <>
      <Grid><h3>Extension for Case #: { controlIdNumber }</h3></Grid>
      {status === STATUS.NONE &&
      <>
        <Grid>
          <DatePicker
            id="due-date-auto"
            label="Requested due date"
            onChange={(dateStr, dateObj) => setDueDate(dateObj)}
          />
        </Grid>
        <Grid>
          <span>To assist your manager in approving this extension request please provide your field efforts, contact efforts or the appointment date if it has been set:</span>
        </Grid>
        <Grid>
          <MSelect
              id="case-extension-reason-select"
              className="md-cell md-cell--12 md-cell--right"
              isClearable={false}
              label="Reason"
              itemLabel="label"
              itemValue="value"
              options={extensionReasons}
              onChange={(reason) => onReasonForExtensionChange(reason)}
          />
          {
            showDatePicker && (
              <DatePicker
                  id="case-extension-reason-datepicker"
                  key="case-extension-reason-datepicker"
                  label="Reason date"
                  pickerHeaderClassName="mcard-date-picker"
                  inline={true}
                  required={showDatePicker}
                  errorText="Date is required."
                  onChange={(newDate) => setReasonDate(newDate)}
              />)
          }
        </Grid>
        <Grid>
          <Button primary raised onClick={submitRequest}>Submit</Button>
        </Grid>
      </>}
      {status === STATUS.SUBMITTING && <Grid><MSpinner /></Grid>}
      {status === STATUS.APPROVED &&
      <Grid>
        <span>Your extension request has been automatically approved.  You may close this window.</span>
      </Grid>}
      {status === STATUS.PENDING &&
      <Grid>
        <span>Your extension request has been sent to your manager for approval.  You may close this window.</span>
      </Grid>}
      {status === STATUS.ERROR &&
      <>
        <Grid>
          <h3>Error</h3>
        </Grid>
        <Grid>
          <span>{errorMessage}</span>
        </Grid>
      </>}
    </>
  );
};


RequestExtension.propTypes = {
  match: PropTypes.object.isRequired,
  makeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  makeToast: text => {
    responseHandler.customToast(text, "error", dispatch);
  }
});

export default connect(null, mapDispatchToProps)(RequestExtension);
